{
  "title": "Beneficiaries",
  "subtitle": "Select a beneficiary previously registered or make a new transaction",
  "loading": "Updating beneficiaries list",
  "input": {
    "accountnumber": "Account number",
    "routingnumber": "Routing number",
    "iban": "IBAN",
    "swiftbic": "Swift BIC"
  },
  "modal": {
    "title": "Beneficiary Details",
    "delete": {
      "title": "Delete Beneficiary",
      "body": "will be deleted from your beneficiaries list. Are you sure you want to proceed?"
    }
  },
  "details": {
    "name": "Name",
    "status": "Status",
    "clabe": "CLABE",
    "additionalInformation": "Additional Information",
    "type": "Account Type",
    "addressLine1": "Address Line 1",
    "postalCode": "Postal Code",
    "city": "City",
    "state": "State",
    "countryCode": "Country",
    "institutionName": "Institution Name",
    "accountNumber": "Account Number",
    "routingNumber": "Routing Number",
    "iban": "IBAN",
    "swiftBic": "Swift BIC",
    "supportedRails": "Supported Rails",
    "assetTypeId": "Asset Type",
    "walletType": "Wallet Type",
    "blockchainAddress": "Wallet Address",
    "address": "Address Line",
    "profileType": "Beneficiary Type"
  }
}
